import { Component, HostBinding, OnInit } from '@angular/core';
import { NotificationService } from '../notification.service';
import { BatchCloningService } from '@main/batch-cloning.service';

@Component({
    selector: 'app-cloning-notification-banner',
    templateUrl: './cloning-notification-banner.component.html',
    styleUrls: ['./cloning-notification-banner.component.css'],
    standalone: true
})
export class CloningNotificationBannerComponent implements OnInit {

  // Properties
  @HostBinding('style.display') public display: string;

  constructor(private batchCloningService: BatchCloningService) { }

  ngOnInit(): void {
    this.batchCloningService.checkCloningProgress().subscribe((event) => {
      if (event.status) this.display = 'block';
      else this.display = 'none';
    });
  }

  // Reload Page
  reloadPage(): void {
    location.reload();
  }
}
